import axios from 'axios'
import Constants from '../constants'

export default {
  getPlaces: (lang) => {
    return new Promise((resolve) => {
      axios.get('place', { params: { id: Constants.API_ID, language: lang } })
        .then(payload => {
          let places = []
          if (payload.data.POI !== undefined) {
            payload.data.POI.forEach((poi) => {
              const g = Object.values(poi.tags)[0]
              const icon = g && g.img ? g.img : ''

              places.push({
                id: poi.poi_id,
                name: poi.shop_name,
                name_yomi: poi.shop_name_yomi,
                location: {
                  latitude: parseFloat(poi.latitude),
                  longitude: parseFloat(poi.longitude)
                },
                address: poi.address,
                genreIds: Object.keys(poi.tags),
                genreWords: Object.values(poi.tags),
                image: poi.img_main,
                detail: poi.shop_introduction,
                zipcode: poi.zipcode,
                access: poi.access,
                tel: poi.tel,
                hours: poi.hours,
                holiday: poi.holiday,
                url: poi.url,
                mapIcon: icon,
                benefits: poi.benefits,
                priority: poi.priority,
                distance: poi.distance,
                station: poi.station,
                busstop: poi.busstop,
                parking: poi.parking
              });
            })
          }
          resolve(places)
        });
    })
  },
  getPlace: (id, token, lang) => {
    return new Promise((resolve) => {
      const params = {
        id: Constants.API_ID,
        poiId: id,
        language: lang,
        token: token
      }
      axios.get('place/detail', { params })
        .then(payload => {
          const place = payload.data
          resolve(Object.assign(place, { genreIds: Object.keys(place.tags) }))
        })
    })
  }
}
